import {
  RolodexEntryJson,
  RolodexEntryType,
} from 'types/rolodex/rolodexEntries'
import { parseString } from 'utils/parsingHelpers'

import { GeckoEntryBase } from './geckoEntry'

export enum LifecycleRecommendationActionKind {
  OpenPlan = 'open-plan',
  OpenAction = 'open-action',
  OpenObservation = 'open-observation',
}

export type LifecycleRecommendationAction =
  | { kind: LifecycleRecommendationActionKind.OpenPlan; planId: string }
  | {
      kind: LifecycleRecommendationActionKind.OpenAction
      actionId: string
      planId: string
    }
  | {
      kind: LifecycleRecommendationActionKind.OpenObservation
      deficiencyId: string
    }

export type LifecycleRecommendationData = {
  title: string
  description: string
  button_label: string
  button_color?: string
  action: LifecycleRecommendationAction | null
}

function parseAction(raw: unknown): LifecycleRecommendationAction | null {
  if (!raw || typeof raw !== 'object') return null
  const action = raw as Record<string, unknown>
  const kind = parseString(action.kind)
  switch (kind) {
    case LifecycleRecommendationActionKind.OpenPlan: {
      const planId = parseString(action.planId)
      return planId
        ? { kind: LifecycleRecommendationActionKind.OpenPlan, planId }
        : null
    }
    case LifecycleRecommendationActionKind.OpenAction: {
      const actionId = parseString(action.actionId)
      const planId = parseString(action.planId)
      return actionId && planId
        ? {
            kind: LifecycleRecommendationActionKind.OpenAction,
            actionId,
            planId,
          }
        : null
    }
    case LifecycleRecommendationActionKind.OpenObservation: {
      const deficiencyId = parseString(action.deficiencyId)
      return deficiencyId
        ? {
            kind: LifecycleRecommendationActionKind.OpenObservation,
            deficiencyId,
          }
        : null
    }
    default:
      return null
  }
}

export class GeckoLifecycleRecommendation extends GeckoEntryBase<
  LifecycleRecommendationData,
  {
    organization?: string
    site?: string
    unit?: string
    [RolodexEntryType.COMPONENT]?: string
  }
> {
  private constructor(json: RolodexEntryJson) {
    super(
      json,
      {
        title: parseString(json.data.title) ?? '',
        description: parseString(json.data.description) ?? '',
        button_label: parseString(json.data.button_label) ?? '',
        button_color: parseString(json.data.button_color),
        action: parseAction(json.data.action),
      },
      {
        organization: parseString(json.tags.organization),
        site: parseString(json.tags.site),
        unit: parseString(json.tags.unit),
        [RolodexEntryType.COMPONENT]: parseString(
          json.tags[RolodexEntryType.COMPONENT]
        ),
      },
      {}
    )
  }

  public static CreateFromJSON(
    json: RolodexEntryJson
  ): GeckoLifecycleRecommendation {
    return new GeckoLifecycleRecommendation(json)
  }
}
